import { atom } from 'jotai';

export const showValueFirstUpgradeModalAtom = atom(false);
